import { useQuery } from '@tanstack/react-query';
import { LoaderCircle } from 'lucide-react';
import { useParams } from 'react-router-dom';

import LogoGeoScalaDark from '@/assets/images/logo-principal-dark.svg';
import LogoGeoScalaLight from '@/assets/images/logo-principal-light.svg';
import TeleattendanceVideoConference from '@/views/teleattendance/components/TeleattendanceVideoConference';
import { fetchRecordingOnboardingInterviewVideoConnection } from '../services/onboardingInterviewService';

const OnboardingInterviewRecordingPage = () => {
  const { token } = useParams();
  const connectionQuery = useQuery({
    queryKey: ['onboarding-interview-recording-video-connection', token],
    queryFn: () =>
      fetchRecordingOnboardingInterviewVideoConnection(String(token)),
    enabled: Boolean(token),
    retry: false,
  });

  if (connectionQuery.isError || !token) {
    return (
      <div className="flex h-dvh items-center justify-center bg-background text-sm text-destructive">
        Não foi possível preparar a gravação.
      </div>
    );
  }

  if (connectionQuery.isLoading || !connectionQuery.data) {
    return (
      <div className="flex h-dvh items-center justify-center bg-background text-muted-foreground">
        <LoaderCircle className="mr-2 h-5 w-5 animate-spin" />
        Preparando gravação...
      </div>
    );
  }

  return (
    <TeleattendanceVideoConference
      connection={connectionQuery.data}
      open
      onOpenChange={() => undefined}
      layoutVariant="doctor"
      presentation="page"
      recordingMode
      initialAudioEnabled={false}
      initialVideoEnabled={false}
      pageBrand={
        <>
          <img
            src={LogoGeoScalaLight}
            alt="Geoescala"
            className="h-8 w-auto dark:hidden"
          />
          <img
            src={LogoGeoScalaDark}
            alt="Geoescala"
            className="hidden h-8 w-auto dark:block"
          />
        </>
      }
      videoLabels={{
        main: 'Entrevista',
        preview: 'Gravação',
      }}
    />
  );
};

export default OnboardingInterviewRecordingPage;
